import api from './interceptor';

const BASE_URL_V2 = 'api/v2/white-label';

export default {
  // API Version 2
  getWhiteLabel: domain => api.get(`${BASE_URL_V2}/no-auth/${domain}`),
  getWhiteLabelByClinicId: clinicId => api.get(`${BASE_URL_V2}/domains/${clinicId}`),
  add: params => api.post(BASE_URL_V2, params),
  update: params => api.patch(BASE_URL_V2, params),
  delete: domain => api.delete(`${BASE_URL_V2}/${domain}`),
};
